import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalEventsHeaderComponent } from './portal-events-header.component';
import { BlockHorizontalScrollerModule } from 'app/shared/components/block-horizontal-scroller/block-horizontal-scroller.module';
import { PortalEventsGQL } from 'app/shared/services/portal-events/graphql/portal-events.gql.service';



import { NgScrollbarModule } from 'ngx-scrollbar';

import { FullHeaderSliderComponent } from 'app/layout/components/full-header-slider/full-header-slider.component';
import { ToolbarHallsComponent } from 'app/layout/components/toolbar-halls/toolbar-halls.component';

@NgModule({
    imports: [
    CommonModule,
    FullHeaderSliderComponent,
    BlockHorizontalScrollerModule,
    ToolbarHallsComponent,
    NgScrollbarModule,
    PortalEventsHeaderComponent
],
    exports: [
        PortalEventsHeaderComponent
    ],
    providers: [
        PortalEventsGQL
    ]
})
export class PortalEventsHeaderModule { }
